export {default} from './feed.vue'